import clsx from 'clsx';
import { LinkProps } from 'next/link';
import React, { ReactNode } from 'react';

import ButtonLink from '../button-link/ButtonLink';
import styles from './HeroButton.module.css';

export interface HeroButtonProps {
  href: LinkProps['href'];
  onClick?: () => void;
  children: ReactNode;
  dataTestId?: string;
}

const HeroButton: React.FC<HeroButtonProps> = ({ children, dataTestId, href, onClick }) => (
  <ButtonLink
    href={href}
    onClick={onClick}
    dataTestId={dataTestId}
    className={clsx(
      styles.button,
      'text-default grid w-full place-items-center rounded-2xl border-2 border-gray-200 bg-white p-6 text-center font-sans text-lg shadow-lg duration-150 ease-in-out',
      'hover:border-primary hover:bg-primary focus:border-primary hover:cursor-pointer hover:text-white hover:shadow-xl',
      'xl:py-8',
    )}>
    {children}
  </ButtonLink>
);

export default HeroButton;
